import Vue from "vue";
import VueRouter, { RouteConfig } from "vue-router";
import ProjectStatus from "../views/ProjectStatus.vue";
import VirtualPublicHearing from "../views/VirtualPublicHearing.vue";
import About from "../views/About.vue";
import HomePage from "../views/HomePage.vue";
import ImageGallery from "../views/ImageGallery.vue";
import FAQs from "../views/FAQs.vue";
import GetInvolved from "../views/GetInvolved.vue";
import DocumentLibrary from "../views/DocumentLibrary.vue";

Vue.use(VueRouter);

const routes: Array<RouteConfig> = [
  {
    path: "/",
    name: "Home",
    component: HomePage
  },
  {
    path: "/about",
    name: "About",
    component: About
  },
  {
    path: "/projectstatus",
    name: "ProjectStatus",
    component: ProjectStatus
  },
  {
    path: "/vph",
    name: "VirtualPublicHearing",
    component: VirtualPublicHearing
  },
  {
    path: "/imagegallery",
    name: "ImageGallery",
    component: ImageGallery
  },
  {
    path: "/getinvolved",
    name: "GetInvolved",
    component: GetInvolved
  },
  {
    path: "/documentlibrary",
    name: "DocumentLibrary",
    component: DocumentLibrary
  },
  {
    path: "/faqs",
    name: "FAQs",
    component: FAQs
  }
];

const router = new VueRouter({
  mode: "history",
  routes,
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  scrollBehavior(to, from, savedPosition) {
    return { x: 0, y: 0 };
  }
});

export default router;
